export default __webpack_public_path__ + "static/media/accountability.2e950a7b.svg";